import { theme } from '../../global/_theme'

export const frontpagePreset = [
  {
    color: theme.quaternary.base,
    animate: true,
    coordinates: {
      vertical: [
        { x: 0, y: 200 },
        { x: 200, y: 0 }
      ],
      horizontal: [
        { x: 0, y: 270 },
        { x: 270, y: 0 }
      ]
    }
  },
  {
    color: theme.tertiary.base,
    animate: true,
    coordinates: {
      vertical: [
        { x: 0, y: 240 },
        { x: 195, y: 45 },
        { x: 148, y: 0 }
      ],
      horizontal: [
        { x: 0, y: 320 },
        { x: 260, y: 60 },
        { x: 198, y: 0 }
      ]
    }
  },
  {
    color: theme.primary.base,
    animate: true,
    coordinates: {
      vertical: [],
      horizontal: [
        { x: 0, y: 200 },
        { x: 84, y: 284 },
        { x: 0, y: 368 }
      ]
    }
  },
  // {
  //   color: theme.primary.base,
  //   animate: true,
  //   coordinates: {
  //     vertical: [
  //       { x: 400, y: 355 },
  //       { x: 240, y: 516 },
  //       { x: 400, y: 677 }
  //     ],
  //     horizontal: [
  //       { x: 490, y: 640 },
  //       { x: 650, y: 480 },
  //       { x: 810, y: 640 }
  //     ]
  //   }
  // },
  // {
  //   color: theme.secondary.base,
  //   animate: true,
  //   coordinates: {
  //     vertical: [
  //       { x: 96, y: 800 },
  //       { x: 400, y: 495 }
  //     ],
  //     horizontal: [
  //       { x: 585, y: 640 },
  //       { x: 870, y: 355 },
  //       { x: 1000, y: 486 }
  //     ]
  //   }
  // },
  {
    color: theme.secondary.base,
    animate: true,
    coordinates: {
      vertical: [
        { x: 400, y: 535 },
        { x: 135, y: 800 }
      ],
      horizontal: [
        { x: 1000, y: 355 },
        { x: 715, y: 640 }
      ]
    }
  },
  {
    color: theme.primary.base,
    animate: true,
    coordinates: {
      vertical: [
        { x: 195, y: 800 },
        { x: 400, y: 595 }
      ],
      horizontal: [
        { x: 1000, y: 440 },
        { x: 932, y: 372 },
        { x: 665, y: 640 }
      ]
    }
  },
  {
    color: theme.tertiary.base,
    animate: true,
    coordinates: {
      vertical: [
        { x: 255, y: 800 },
        { x: 400, y: 655 }
      ],
      horizontal: []
    }
  }
]
